'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _includes = require('lodash/includes');var _includes2 = _interopRequireDefault(_includes);
var _pickBy = require('lodash/pickBy');var _pickBy2 = _interopRequireDefault(_pickBy);
var _keys = require('lodash/keys');var _keys2 = _interopRequireDefault(_keys);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _components = require('../../components');









var _PublishPropertyFormConstants = require('./PublishPropertyFormConstants');
var _publish = require('../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);

var _PublishPropertyForm = require('./PublishPropertyForm.scss');var styles = _interopRequireWildcard(_PublishPropertyForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var AboutPropertyBlock = function (_Component) {_inherits(AboutPropertyBlock, _Component);function AboutPropertyBlock() {var _temp, _this, _ret;_classCallCheck(this, AboutPropertyBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.















































    setBalconiesAreaFieldsLength = function (nextValue, currentValue) {var
      balconies_area = _this.props.fields.balconies_area;
      if (nextValue < currentValue) {
        var newArray = balconies_area.reduce(function (acc, element, index) {
          if (index < nextValue) {
            acc.push(element);
          }
          return acc;
        }, []);
        _this.props.changeValue('balconies_area', newArray);
      } else {
        var difference = nextValue - currentValue;
        var _newArray = [].concat(balconies_area);
        for (var i = 1; i <= difference; i++) {// eslint-disable-line
          _newArray.push('');
        }
        _this.props.changeValue('balconies_area', _newArray);
      }
    }, _this.

    transformBalconiesNumberToArray = function (balconies) {
      var number = balconies && +balconies;
      var balconiesArea = [];
      if (number) {
        for (var i = 1; i <= number; i++) {// eslint-disable-line
          balconiesArea.push('');
        }
      }
      return balconiesArea;
    }, _this.

    renderMultiSegmentedControl = function (values, name) {var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var
      fields = _this.props.fields;
      var fieldValue = fields[name] && field.length ? fields[name][field] : fields[name];
      return (
        _react2.default.createElement(_components.OMSegmentedControl, {
          inReduxForm: true,
          className: 'multiButtons rounded',
          name: field.length ? name + '.' + field : name,
          values: values,
          selectedValue: fields[name] && fieldValue ? fieldValue : values[0].value }));

    }, _this.

    renderInput = function (_ref) {var input = _ref.input,meta = _ref.meta,placeholder = _ref.placeholder;
      var inputPlaceholder = placeholder || '';
      switch (input.name.split('.')[0]) {
        case 'area':{inputPlaceholder = _this.props.translate('square');break;}
        case 'rooms':{inputPlaceholder = _this.props.translate('numberOfRoomsPlaceholder');break;}
        case 'floor':{inputPlaceholder = _this.props.translate('floorsAmount');break;}
        default:}


      return _react2.default.createElement('input', _extends({},
      input, {
        type: 'text',
        placeholder: inputPlaceholder,
        className: (0, _classnames2.default)(styles.inputNumb, styles.numeric, 'form-control',
        { not_valid: meta.touched && meta.error && !meta.active }) }));

    }, _this.























    renderFloorInput = function (_ref2) {var input = _ref2.input,meta = _ref2.meta;return _react2.default.createElement('input', _extends({},
      input, {
        type: 'text',
        placeholder: _this.props.translate(input.name),
        className: (0, _classnames2.default)(styles.inputNumb2, styles.numeric, 'form-control',
        { not_valid: meta.touched && meta.error && !meta.active }) }));}, _this.























































    renderBalconiesAreaFields = function (_ref3) {var fields = _ref3.fields;return (
        _react2.default.createElement('div', { className: styles.balconiesAreaWrapper }, fields.map(function (item, index) {return (
              _react2.default.createElement(_reduxForm.Field, {
                component: _this.renderInput,
                type: 'text',
                name: item,
                key: item,
                placeholder: _this.props.translate('balconiesAreaInputPlaceholder') + ' ' + (index + 1),
                normalize: _publish2.default.area }));})));}, _this.





    renderBalconiesArea = function () {return (
        _react2.default.createElement(_reactScroll.Element, { name: 'balconies_area' },
          _react2.default.createElement(_reduxForm.FieldArray, {
            name: 'balconies_area',
            component: _this.renderBalconiesAreaFields })));}, _temp), _possibleConstructorReturn(_this, _ret);}AboutPropertyBlock.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref4) {var fields = _ref4.fields,config = _ref4.config;var floorOn = (0, _get2.default)(fields, 'floor.on_the');var oldFloorOn = (0, _get2.default)(this.props, 'fields.floor.on_the');if (fields.groundFloor && !this.props.fields.groundFloor) {this.props.changeValue('floor.on_the', 0);}if (!fields.groundFloor && this.props.fields.groundFloor) {this.props.changeValue('floor.on_the', null);}if (config.floors && floorOn === 0 && floorOn !== oldFloorOn) {this.props.changeValue('groundFloor', true);}if (config.floors && oldFloorOn === 0 && floorOn !== oldFloorOn) {this.props.changeValue('groundFloor', false);}if (config.cottageArea && floorOn !== oldFloorOn) {this.props.changeValue('floor.out_of', floorOn);}if (fields.balconies && (!this.props.fields.balconies || this.props.fields.balconies === '0' || !fields.balconies_area)) {this.props.changeValue('balconies_area', this.transformBalconiesNumberToArray(fields.balconies));}if (fields.balconies !== this.props.fields.balconies && (this.props.fields.balconies || this.props.fields.balconies === '0')) {this.setBalconiesAreaFieldsLength(fields.balconies, this.props.fields.balconies);}if (config.toilets && !fields.toilets) {this.props.changeValue('toilets', 1);}if (config.bath && !fields.bathrooms) {this.props.changeValue('bathrooms', 1);}};AboutPropertyBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref5) {var fields = _ref5.fields,locale = _ref5.locale,config = _ref5.config;var fieldsChanged = !(0, _isEqual2.default)(this.props.fields, fields);var configChanged = !(0, _isEqual2.default)(this.props.config, config);var localeChanged = this.props.locale !== locale;return fieldsChanged || localeChanged || configChanged;};AboutPropertyBlock.prototype.renderInputRow = function renderInputRow(field, label, isRequired) {var normalizeField = field.split('.')[0] === 'area' ? 'area' : field;return _react2.default.createElement('div', { className: styles.requiredFieldWrapper }, _react2.default.createElement('span', { className: 'label' }, this.props.translate(label), isRequired && _react2.default.createElement('span', { className: 'req' }, '*')), _react2.default.createElement('div', { className: 'fieldset' }, _react2.default.createElement(_reactScroll.Element, { name: label }, _react2.default.createElement(_reduxForm.Field, { props: { locale: this.props.locale }, name: field, component: this.renderInput, normalize: _publish2.default[normalizeField] }))));};AboutPropertyBlock.prototype.renderFloorsBlock = function renderFloorsBlock() {var _this2 = this;var _props$config = this.props.config,floorsAmount = _props$config.floorsAmount,floors = _props$config.floors;var checkboxName = floorsAmount ? 'hasBasement' : 'groundFloor';var floorTitle = floorsAmount ? 'floorsAmount' : 'floor';return (floorsAmount || floors) && _react2.default.createElement('div', { className: styles.requiredFieldWrapper }, _react2.default.createElement('span', { className: (0, _classnames2.default)('label', styles.labelTop, styles.fixedLineHeight) }, this.props.translate(floorTitle), _react2.default.createElement('span', { className: 'req' }, '*')), _react2.default.createElement('div', { className: 'fieldset' }, _react2.default.createElement(_reactScroll.Element, { name: 'floor', className: styles.floorWrapper }, _react2.default.createElement(_reduxForm.Field, { props: { locale: this.props.locale }, name: 'floor.on_the', component: this.props.config.floorsAmount ? this.renderInput : this.renderFloorInput, normalize: _publish2.default['floor.on_the'] }), this.props.config.floors && _react2.default.createElement('span', { className: styles.indentedString }, this.props.translate('of')), this.props.config.floors && _react2.default.createElement(_reduxForm.Field, { props: { locale: this.props.locale }, name: 'floor.out_of', placeholder: '' + this.props.translate('floor.out_of'), className: (0, _classnames2.default)(styles.inputNumb, styles.numeric, 'form-control'), tooltipMessage: '' + this.props.translate('floorTooltipMessage'), isRtl: this.props.isRtl, component: _components.OMInputWithTooltip, normalize: _publish2.default['floor.out_of'] })), _react2.default.createElement('div', { className: styles.groundFloorBlock }, _react2.default.createElement(_reduxForm.Field, { props: { locale: this.props.locale }, name: checkboxName, normalize: _publish2.default[checkboxName], component: function component(_ref6) {var input = _ref6.input;return _react2.default.createElement(_components.OMCheckbox, { id: checkboxName, field: Object.assign({}, input, { checked: input.value }), label: '' + _this2.props.translate(checkboxName) });} }))));};AboutPropertyBlock.prototype.




  render = function render() {var _props =
    this.props,config = _props.config,fields = _props.fields,locale = _props.locale;
    var areaLabel = config.fieldArea ? 'cottageArea' : 'squareMeterArea';
    var options = (0, _PublishPropertyFormConstants.commoditiesOptions)(this.props.translate);
    var configPropertyCommodities = (0, _pickBy2.default)(config.propertyCommodities, function (item) {return item;});
    var commoditiesKeys = (0, _keys2.default)(configPropertyCommodities);
    var commodities = options.filter(function (item) {return (0, _includes2.default)(commoditiesKeys, item.id);});
    var shouldRenderBalconiesArea = fields.balconies_area && fields.balconies !== '0';

    return (
      _react2.default.createElement(_reactScroll.Element, { name: 'aboutProperty', className: styles.sectionBlock },
        _react2.default.createElement('div', { className: styles.title }, this.props.translate('sections', 'propertyDetails')),
        config.rooms && _react2.default.createElement(_reactScroll.Element, { name: 'rooms' }, this.renderInputRow('rooms', 'numberOfRooms', 'isRequired')),

        config.area && _react2.default.createElement(_reactScroll.Element, { name: 'area' }, this.renderInputRow('area.base', areaLabel, 'isRequired')),

        config.fieldArea && this.renderInputRow('area.field', 'fieldArea'),

        config.gardenArea && this.renderInputRow('area.garden', 'gardenArea'),

        this.renderFloorsBlock(),

        config.parking && _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
          !this.props.isMobile ?
          _react2.default.createElement('div', { className: (0, _classnames2.default)('label', styles.labelTop) },
            this.props.translate('parking')) :

          null,
          _react2.default.createElement('div', { className: 'fieldset' },
            _react2.default.createElement('div', { className: 'form-group' },
              _react2.default.createElement('p', null,
                this.props.isMobile ?
                this.props.translate('mobileParking', 'ground') :
                this.props.translate('ground')),


              this.renderMultiSegmentedControl((0, _PublishPropertyFormConstants.parking)(this.props.translate), 'parking', 'aboveground')),

            _react2.default.createElement('div', { className: 'form-group' },
              _react2.default.createElement('p', null,
                this.props.isMobile ?
                this.props.translate('mobileParking', 'underground') :
                this.props.translate('underground')),


              this.renderMultiSegmentedControl((0, _PublishPropertyFormConstants.parking)(this.props.translate), 'parking', 'underground')))),




        config.balconies && _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
          _react2.default.createElement('span', { className: (0, _classnames2.default)('label', styles.labelMid) }, this.props.translate('balcony')),
          _react2.default.createElement('div', { className: 'fieldset' },
            this.renderMultiSegmentedControl((0, _PublishPropertyFormConstants.balcony)(this.props.translate), 'balconies'))),



        shouldRenderBalconiesArea && _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
          _react2.default.createElement('span', { className: (0, _classnames2.default)('label', styles.labelMid) }, this.props.translate('balconiesArea')),
          this.renderBalconiesArea()),


        config.windDirections && _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.requiredFieldWrapper, styles.windDirection) },
          _react2.default.createElement('span', { className: (0, _classnames2.default)('label', styles.labelTop) }, this.props.translate('directionOfTheWind')),
          _react2.default.createElement('div', { className: 'fieldset' },
            _react2.default.createElement(_components.OMWindDirection, {
              translate: this.props.translate('compass'),
              changeValue: this.props.changeValue,
              locale: this.props.locale,
              registerNewField: this.props.registerNewField,
              lightDirection: fields.light_direction }))),




        config.bath && _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
          _react2.default.createElement('span', { className: (0, _classnames2.default)('label', styles.labelMid) }, this.props.translate('bath')),
          _react2.default.createElement('div', { className: 'fieldset' },
            this.renderMultiSegmentedControl(_PublishPropertyFormConstants.bathrooms, 'bathrooms'))),



        config.toilets && _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
          _react2.default.createElement('span', { className: (0, _classnames2.default)('label', styles.labelMid) }, this.props.translate('toilets')),
          _react2.default.createElement('div', { className: 'fieldset' },
            this.renderMultiSegmentedControl(_PublishPropertyFormConstants.bathrooms, 'toilets'))),



        config.tax && !this.props.isForeign && _react2.default.createElement(_components.OMPriceInput, {
          field: 'payments.tax',
          locale: locale,
          label: '' + this.props.translate('tax_for_two_months'),
          placeholder: '' + this.props.translate('tax'),
          className: styles.tax,
          isMobile: this.props.isMobile }),


        config.propertyCommodities && !!commodities.length &&
        _react2.default.createElement('div', { className: styles.requiredFieldWrapper },
          _react2.default.createElement('span', { className: (0, _classnames2.default)('label', styles.labelMid) }, this.props.translate('commodities')),
          _react2.default.createElement('div', { className: (0, _classnames2.default)('fieldset', styles.commodities) },
            _react2.default.createElement(_reduxForm.Field, {
              props: { locale: locale },
              name: 'commodities',
              component: function component(_ref7) {var input = _ref7.input;return (
                  _react2.default.createElement(_components.OMMultiCheckbox, _extends({ options: commodities }, input)));} })))));






  };return AboutPropertyBlock;}(_react.Component);exports.default = AboutPropertyBlock;


AboutPropertyBlock.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  config: _propTypes2.default.object.isRequired,
  fields: _propTypes2.default.object.isRequired,
  changeValue: _propTypes2.default.func.isRequired,
  registerNewField: _propTypes2.default.func.isRequired,
  searchOption: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/AboutPropertyBlock.js
// module id = 3019
// module chunks = 0